import React, { Component } from 'react';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import { connect } from 'react-redux'; // to connect to redux store from containers redux.js or any other redux store
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component
import { is } from 'immutable'; // use of immutablejs for various js operations to simplify our work
import renderIf from 'render-if';// to use conditional rendering based on values that is provided to component
import CoachPostings from 'components/CoachPostings';
import AddPosting from 'components/AddPosting';
import EditPosting from 'components/EditPosting';
import FullScreenLoader from 'components/FullScreenLoader';// to show loder on screen whenever there is a api call or operations in component
import {
  addPostings,
  getAllPostings,
  updatePostings,
  deleteposting,
  createAllPostingForThisCollege } from './actions';
import { postings } from './redux';
import styles from './Postings.scss';
// to import local scss fle

class Postings extends Component {
  static propTypes = {
    attributes: PropTypes.shape(),
    allPostings: PropTypes.shape(),
    getAllPostings: PropTypes.func,
    postingGettingAdded: PropTypes.bool,
    postingGettingDeleted: PropTypes.bool,
    requestPostings: PropTypes.bool,
    editPostingRequested: PropTypes.bool,
  };

  static defaultProps = {
    attributes: {},
    allPostings: {},
    getAllPostings: () => {},
    postingGettingAdded: false,
    postingGettingDeleted: false,
    postingDeleted: false,
    requestPostings: false,
    editPostingRequested: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      editPost: false,
      postingId: '',
      postingIndex: 0,
    };
    this.editPosting = this.editPosting.bind(this);
    this.setPostingId = this.setPostingId.bind(this);
  }

  componentWillMount() {
    if (this.props.attributes.size > 0) {
      const id = this.props.attributes.get('profile');
      this.props.getAllPostings(id);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.attributes.size > 0 && !is(nextProps.attributes, this.props.attributes)) {
      const id = nextProps.attributes.get('profile');
      this.props.getAllPostings(id);
    }
  }

  setPostingId(id, index) {
    this.setState({ postingId: id, postingIndex: index });
  }

  editPosting(item) {
    this.setState({ editPost: !this.state.editPost, currentPosting: item });
  }

  render() {
    /* let finalPostings = [];
    if (this.props.postingDeleted === true) {
      finalPostings = [];
    } else {
      finalPostings = this.props.allPostings;
    } */
    const allPostings = this.props.allPostings;
    const renderLoader = renderIf(this.props.postingGettingAdded || this.props.editPostingRequested
                          || this.props.postingGettingDeleted || this.props.requestPostings);
    const renderEditPost = renderIf(this.state.editPost);
    const renderNoPostings = renderIf(this.props.requestPostings === false &&
                     this.props.allPostings.size === 0 && !this.props.postingGettingAdded);
    return (
      <div className={cn('row', styles.container)}>
        <AddPosting {...this.props} />
        {renderEditPost(
          <EditPosting
            {...this.state}
            {...this.props}
            currentPosting={this.state.currentPosting}
            openPosting={this.state.editPost}
            editPosting={() => this.editPosting()}
          />,
          )}

        <div className={cn('col s12', styles.coachPostings)}>
          {renderLoader(
            <span>
              <FullScreenLoader />
            </span>,
            )}
          {renderNoPostings(
            <div className={cn('col s12', styles.emptyScreens)}>
              <div className={styles.emptyImage}>
                <img src="https://media.dev.myrecruitboard.com/Images/no-content-found%403x.png" alt="empty screen" />
              </div>
              <div className={styles.noDescFound}>
                      You don&#39;t have any postings.
                  </div>
            </div>,
            )}
          {allPostings.map((item, index) => (
            <CoachPostings
              {...this.props}
              item={item}
              index={index}
              editPosting={() => this.editPosting(item)}
              setPostingId={this.setPostingId}
            />
                ))}

        </div>
      </div>
    );
  }
}

export default
connect(postings, {
  addPostings,
  getAllPostings,
  updatePostings,
  createAllPostingForThisCollege,
  deleteposting,
})(Postings);



// WEBPACK FOOTER //
// ./src/components/Postings/Postings.js